/**
 * Removes all duplicate elements from an array.
 * @param {string[]} array - The array to remove duplicates from.
 * @returns {string[]} A new array with all duplicate elements removed.
 */
export const removeDuplicatesFromArray = (array: string[]) => {
  return [...new Set(array)];
};
